import { Skeleton } from '@/ui/skeleton'

type DynamicConfigFormSkeletonProps = {
  rowCount?: number
}

export function DynamicConfigFormSkeleton({
  rowCount = 6,
}: Readonly<DynamicConfigFormSkeletonProps>) {
  const skeletonRowKeys = Array.from({ length: rowCount }, (_, index) => `row-${index + 1}`)

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      {skeletonRowKeys.map(key => (
        <Skeleton key={key} style={{ height: 40, width: '100%' }} />
      ))}
    </div>
  )
}
